(function () {
  'use strict';

  var root = document.querySelector('[data-compare-page]');
  if (!root) return;

  var configElement = root.parentNode.querySelector('[data-compare-config]');
  if (!configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }

  var products = config.products || [];
  if (!products.length) return;

  var mobileQuery = window.matchMedia('(max-width: 740px)');
  var isMobile = mobileQuery.matches;
  var defaultDesktop = ['core', 'gen2', 'plus'];
  var defaultMobile = ['core', 'plus'];
  var rowOrder = {
    dimensions: ['size', 'height'],
    load: ['load'],
    ac: ['ac'],
    usb: ['charging', 'bridging'],
    wireless: ['wireless'],
    cable: ['size', 'organizer'],
    light: ['cri', 'width', 'configurations', 'presets'],
    compatibility: ['desk']
  };
  var sectionBlocks = config.sectionBlocks || [];
  var sectionOrder = ['overview'].concat(sectionBlocks.map(function (section) {
    return section.id;
  }).filter(function (id) {
    return id === 'materials' || id === 'footnotes' || rowOrder[id];
  }));
  var navigationOrder = sectionOrder.filter(function (id) {
    return id !== 'footnotes';
  });
  var state = {
    slots: [],
    activeSection: 'overview'
  };
  var navObserver;
  var scrollFrame;
  var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
  var headerHidden = false;
  var colorState = {};

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function lineBreaks(value) {
    return escapeHtml(value).replace(/\r?\n/g, '<br>');
  }

  function imageAttributes(product, loading, prioritized) {
    var width = Number(product.imageWidth);
    var height = Number(product.imageHeight);
    var dimensions = width > 0 && height > 0 ? ' width="' + width + '" height="' + height + '"' : '';
    return dimensions + ' loading="' + loading + '" decoding="async"' + (prioritized ? ' fetchpriority="high"' : '');
  }

  function sectionHeadingMarkup(value) {
    var text = String(value == null ? '' : value);
    var match = text.match(/^(.*?)(?:\s+(\d+)|(\d+))$/);
    if (!match) return escapeHtml(text);
    return escapeHtml(match[1]) + ' <sup class="compare-section__footnote">' + escapeHtml(match[2] || match[3]) + '</sup>';
  }

  function productFor(id) {
    return products.find(function (product) {
      return product.id === id;
    }) || products[0];
  }

  function hasProduct(id) {
    return products.some(function (product) {
      return product.id === id;
    });
  }

  function defaultsForViewport() {
    var defaults = isMobile ? defaultMobile : defaultDesktop;
    return defaults.slice(0, isMobile ? 2 : 3).map(function (id, index) {
      return hasProduct(id) ? id : (products[index] || products[0]).id;
    });
  }

  function syncSlots() {
    var targetCount = isMobile ? 2 : 3;
    var defaults = defaultsForViewport();
    state.slots = state.slots.slice(0, targetCount).map(function (id, index) {
      return hasProduct(id) ? id : defaults[index];
    });
    while (state.slots.length < targetCount) {
      var next = defaults[state.slots.length] || products[0].id;
      if (state.slots.indexOf(next) !== -1) {
        var unused = products.find(function (product) {
          return state.slots.indexOf(product.id) === -1;
        });
        next = unused ? unused.id : next;
      }
      state.slots.push(next);
    }
  }

  function actionMarkup(product) {
    var label = escapeHtml(config.ui.orderNow);
    if (!product.href) {
      return '<span class="compare-product__action is-disabled" aria-disabled="true">' + label + '</span>';
    }
    return '<a class="compare-product__action" href="' + escapeHtml(product.href) + '">' + label + '</a>';
  }

  function productOptionMarkup(product, slot) {
    var selected = product.id === state.slots[slot];
    return (
      '<button class="compare-product__option" type="button" role="option" tabindex="0" ' +
      'aria-selected="' + selected + '" data-product-option data-slot="' + slot + '" data-product-id="' +
      escapeHtml(product.id) + '">' +
      '<span>' + escapeHtml(product.name) + '</span>' +
      '<span class="compare-product__option-mark" aria-hidden="true"></span>' +
      '</button>'
    );
  }

  function productMarkup(product, slot, compact, prefix) {
    var menuId = prefix + '-menu-' + slot;
    var description = isMobile && product.mobileDescription ? product.mobileDescription : product.description;
    var image = compact ? '' :
      '<img class="compare-product__image" src="' + escapeHtml(product.image) + '" alt="' +
      escapeHtml(product.name) + '"' + imageAttributes(product, slot === 0 ? 'eager' : 'lazy', slot === 0) + '>';

    return (
      '<article class="compare-product' + (compact ? ' compare-product--compact' : '') + '" data-product-slot="' + slot + '">' +
      image +
      '<div class="compare-product__info">' +
      '<div class="compare-product__selector-wrap" data-open="false">' +
      '<button class="compare-product__selector" type="button" aria-label="' +
      escapeHtml(config.ui.selectModel + ': ' + product.name) + '" aria-expanded="false" aria-haspopup="listbox" aria-controls="' +
      menuId + '" data-product-trigger data-slot="' + slot + '">' +
      '<span class="compare-product__name">' + escapeHtml(product.name) + '</span>' +
      '<span class="compare-chevron" aria-hidden="true"></span>' +
      '</button>' +
      '<div class="compare-product__menu" id="' + menuId + '" role="listbox" aria-label="' +
      escapeHtml(config.ui.selectModel) + '">' +
      products.map(function (option) {
        return productOptionMarkup(option, slot);
      }).join('') +
      '</div>' +
      '</div>' +
      '<p class="compare-product__description">' + lineBreaks(description) + '</p>' +
      '</div>' +
      '<div class="compare-product__actions">' +
      actionMarkup(product) +
      (product.price ? '<span class="compare-product__price">' + escapeHtml(product.price) + '</span>' : '') +
      '</div>' +
      '</article>'
    );
  }

  function syncPriceRows() {
    root.querySelectorAll('.compare-products').forEach(function (group) {
      var prices = Array.from(group.querySelectorAll('.compare-product__price'));
      prices.forEach(function (price) {
        price.classList.remove('is-multiline');
      });
      if (!isMobile) return;
      var hasMultilinePrice = prices.some(function (price) {
        var range = document.createRange();
        range.selectNodeContents(price);
        return range.getClientRects().length > 1;
      });
      if (hasMultilinePrice) {
        prices.forEach(function (price) {
          price.classList.add('is-multiline');
        });
      }
    });
  }

  function renderProducts() {
    var host = root.querySelector('[data-compare-products]');
    if (!host) return;
    host.innerHTML = state.slots.map(function (id, slot) {
      return productMarkup(productFor(id), slot, false, 'compare-product');
    }).join('');
  }

  function renderCompact() {
    var host = root.querySelector('[data-compare-compact-products]');
    if (!host) return;
    host.innerHTML = '<div class="compare-products">' + state.slots.map(function (id, slot) {
      return productMarkup(productFor(id), slot, true, 'compare-compact-product');
    }).join('') + '</div>';
  }

  function featureCell(product, sectionId, rowId) {
    var feature = product.features && product.features[sectionId] && product.features[sectionId][rowId];
    if (!feature) {
      return '<div class="compare-feature-cell"><p class="compare-feature__copy">—</p></div>';
    }

    if (feature.icon) {
      return (
        '<div class="compare-feature-cell">' +
        '<img class="compare-feature__icon" src="' + escapeHtml(config.icons[feature.icon]) + '" alt="" aria-hidden="true" focusable="false" loading="lazy" decoding="async">' +
        '<p class="compare-feature__copy">' + lineBreaks(feature.text) + '</p>' +
        '</div>'
      );
    }

    return (
      '<div class="compare-feature-cell">' +
      '<p class="compare-feature__value">' + lineBreaks(feature.value) + '</p>' +
      (feature.label ? '<p class="compare-feature__label">' + lineBreaks(feature.label) + '</p>' : '') +
      '</div>'
    );
  }

  function featureMatrixMarkup(sectionId) {
    return '<div class="compare-feature-matrix">' + rowOrder[sectionId].map(function (rowId) {
      return (
        '<div class="compare-feature-row" data-kind="' + rowId + '">' +
        state.slots.map(function (id) {
          return featureCell(productFor(id), sectionId, rowId);
        }).join('') +
        '</div>'
      );
    }).join('') + '</div>';
  }

  function colorVariantFor(product) {
    var variants = product.colorVariants || [];
    if (!variants.length) return null;
    return variants.find(function (variant) {
      return variant.id === colorState[product.id];
    }) || variants.find(function (variant) {
      return variant.default;
    }) || variants[0];
  }

  function colorOptionMarkup(product, variant) {
    var selected = colorVariantFor(product) === variant;
    var swatch = variant.swatch === 'silver' ? 'silver' : 'dark';
    return (
      '<button class="compare-material__swatch compare-material__swatch--' + swatch + '" type="button" ' +
      'aria-label="' + escapeHtml(variant.name) + '" aria-pressed="' + selected + '" ' +
      'data-color-option data-product-id="' + escapeHtml(product.id) + '" data-color-id="' + escapeHtml(variant.id) + '"></button>'
    );
  }

  function materialsMarkup() {
    return '<div class="compare-materials-grid">' + state.slots.map(function (id) {
      var product = productFor(id);
      var variant = colorVariantFor(product);
      var description = String((variant && variant.description) || '').split(/\r?\n/).map(function (line) {
        return '<li>' + escapeHtml(line) + '</li>';
      }).join('');
      var image = variant && variant.image ? variant : product;
      return (
        '<article class="compare-material">' +
        '<img class="compare-material__image" src="' + escapeHtml(image.image) + '" alt="' +
        escapeHtml(product.name + (variant && variant.name ? ' ' + variant.name : '')) + '"' + imageAttributes(image, 'lazy', false) + '>' +
        '<div class="compare-material__swatches">' + (product.colorVariants || []).map(function (option) {
          return colorOptionMarkup(product, option);
        }).join('') + '</div>' +
        '<p class="compare-material__name">' + escapeHtml((variant && variant.name) || '') + '</p>' +
        '<div class="compare-material__description"><ul>' + description + '</ul></div>' +
        '</article>'
      );
    }).join('') + '</div>';
  }

  function selectColor(productId, colorId) {
    var product = productFor(productId);
    var variant = (product.colorVariants || []).find(function (option) {
      return option.id === colorId;
    });
    if (!variant) return;
    colorState[productId] = colorId;
    renderSections();
    setupObservers();
    setActiveSection(state.activeSection);
  }

  function sectionTargetId(id) {
    return id === 'overview' ? 'overview' : 'compare-section-' + id;
  }

  function sectionBlockFor(id) {
    return sectionBlocks.find(function (section) {
      return section.id === id;
    });
  }

  function sectionLabel(id) {
    var section = sectionBlockFor(id);
    return section && section.navLabel ? section.navLabel : config.ui.sections[id];
  }

  function sectionHeading(id) {
    var section = sectionBlockFor(id);
    return section && section.heading ? section.heading : config.ui.headings[id];
  }

  function renderSections() {
    var host = root.querySelector('[data-compare-sections]');
    if (!host) return;
    host.innerHTML = sectionOrder.slice(1).map(function (id) {
      var section = sectionBlockFor(id);
      if (id === 'footnotes') {
        var notes = String(section.text || '').split(/\r?\n/).filter(function (note) {
          return note.trim();
        }).map(function (note) {
          return '<p>' + escapeHtml(note.trim()) + '</p>';
        }).join('');
        return '<div class="compare-page__notes"' +
          (section.editorAttributes ? ' ' + section.editorAttributes : '') + '>' + notes + '</div>';
      }
      var content = id === 'materials' ? materialsMarkup() : featureMatrixMarkup(id);
      return (
        '<section class="compare-section compare-section--' + id + '" id="' + sectionTargetId(id) +
        '" data-compare-section="' + id + '" aria-labelledby="compare-heading-' + id + '"' +
        (section && section.editorAttributes ? ' ' + section.editorAttributes : '') + '>' +
        '<h2 class="compare-section__title" id="compare-heading-' + id + '">' +
        sectionHeadingMarkup(sectionHeading(id)) + '</h2>' +
        '<div class="compare-section__rule" aria-hidden="true"></div>' +
        content +
        '</section>'
      );
    }).join('');
  }

  function navLinkMarkup(id, mobile) {
    return (
      '<a class="compare-nav__link" href="#' + sectionTargetId(id) + '"' + (mobile ? ' role="menuitem"' : '') +
      ' data-compare-nav-link data-section-id="' + id + '">' +
      escapeHtml(sectionLabel(id)) + '</a>'
    );
  }

  function renderNavigation() {
    var nav = root.querySelector('[data-compare-nav]');
    if (nav) {
      nav.innerHTML = navigationOrder.map(function (id) {
        return '<li class="compare-nav__item">' + navLinkMarkup(id, false) + '</li>';
      }).join('');
    }

    root.querySelectorAll('[data-compare-section-menu]').forEach(function (menu) {
      menu.innerHTML = navigationOrder.map(function (id) {
        return navLinkMarkup(id, true);
      }).join('');
    });
  }

  function setActiveSection(id) {
    if (!id || navigationOrder.indexOf(id) === -1) return;
    state.activeSection = id;
    root.querySelectorAll('[data-compare-nav-link]').forEach(function (link) {
      var active = link.getAttribute('data-section-id') === id;
      link.classList.toggle('is-active', active);
      if (active) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }
    });
    root.querySelectorAll('[data-compare-current-section]').forEach(function (current) {
      current.textContent = id === 'overview' ? config.ui.exploreSpecifications : sectionLabel(id);
    });
  }

  function setSectionPickerOpen(open, targetPicker) {
    root.querySelectorAll('[data-compare-picker]').forEach(function (picker) {
      var active = open && (!targetPicker || picker === targetPicker);
      picker.setAttribute('data-open', active ? 'true' : 'false');
      picker.querySelector('[data-compare-section-trigger]').setAttribute('aria-expanded', active ? 'true' : 'false');
    });
  }

  function setProductMenuOpen(wrap, open) {
    wrap.setAttribute('data-open', open ? 'true' : 'false');
    var trigger = wrap.querySelector('[data-product-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeProductMenus(except) {
    root.querySelectorAll('.compare-product__selector-wrap[data-open="true"]').forEach(function (wrap) {
      if (wrap !== except) setProductMenuOpen(wrap, false);
    });
  }

  function closeMenus() {
    closeProductMenus(null);
    setSectionPickerOpen(false);
  }

  function focusFirstOption(wrap) {
    var first = wrap.querySelector('[data-product-option]');
    if (first) first.focus();
  }

  function selectProduct(slot, id, focusCompact) {
    if (!hasProduct(id)) return;
    var duplicateSlot = state.slots.indexOf(id);
    if (duplicateSlot !== -1 && duplicateSlot !== slot) {
      var previousId = state.slots[slot];
      state.slots[slot] = id;
      state.slots[duplicateSlot] = previousId;
    } else {
      state.slots[slot] = id;
    }
    closeMenus();
    renderProducts();
    renderCompact();
    syncPriceRows();
    renderSections();
    setupObservers();
    setActiveSection(state.activeSection);
    var product = productFor(id);
    var live = root.querySelector('[data-compare-live]');
    if (live) live.textContent = product.name;
    var triggerHost = focusCompact ? root.querySelector('[data-compare-compact-products]') : root.querySelector('.compare-page__content');
    var trigger = triggerHost && triggerHost.querySelector('[data-product-trigger][data-slot="' + slot + '"]');
    if (trigger) trigger.focus();
  }

  function navigateTo(id) {
    var target = document.getElementById(sectionTargetId(id));
    if (!target) return;
    setSectionPickerOpen(false);
    var currentTop = getScrollTop();
    var documentTargetTop = target.getBoundingClientRect().top + currentTop;
    var targetTop = Math.max(0, documentTargetTop - getNavigationOffset(id, documentTargetTop, currentTop));
    window.scrollTo({
      top: targetTop,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  function getScrollTop() {
    return Math.max(0, window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);
  }

  function getHeaderHeight() {
    var configuredHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    if (configuredHeight > 0) return configuredHeight;
    var header = document.querySelector('.shopify-section--header');
    return header ? header.getBoundingClientRect().height : 0;
  }

  function getHeaderOffset() {
    return document.body.classList.contains('compare-page--header-hidden') ? 0 : getHeaderHeight();
  }

  function getNavigationOffset(id, documentTargetTop, currentTop) {
    if (id === 'overview' || documentTargetTop < currentTop - 1) {
      setHeaderHidden(false);
    } else if (documentTargetTop > currentTop + 1) {
      setHeaderHidden(true);
    }

    var headerOffset = getHeaderOffset();
    var sticky = root.querySelector('[data-compare-compact]');
    var stickyHeight = 0;
    var overview = root.querySelector('[data-compare-section="overview"]');
    if (sticky && id !== 'overview' && overview) {
      var overviewBottom = overview.getBoundingClientRect().bottom + currentTop;
      var scrollWithoutSticky = documentTargetTop - headerOffset - 12;
      if (scrollWithoutSticky > overviewBottom) stickyHeight = sticky.offsetHeight;
    }
    return headerOffset + stickyHeight + 12;
  }

  function setHeaderHidden(hidden) {
    if (hidden === headerHidden) return;
    headerHidden = hidden;
    document.body.classList.toggle('compare-page--header-hidden', hidden);
  }

  function updateHeaderVisibility() {
    var current = getScrollTop();
    var delta = current - lastScrollTop;

    if (current <= 24) {
      setHeaderHidden(false);
    } else if (delta > 2) {
      setHeaderHidden(true);
    } else if (delta < -2) {
      setHeaderHidden(false);
    }

    lastScrollTop = current;
  }

  function updateActiveFromScroll() {
    var targets = navigationOrder.map(function (id) {
      return document.getElementById(sectionTargetId(id));
    }).filter(Boolean);
    var compact = root.querySelector('[data-compare-compact]');
    var overview = document.querySelector('[data-compare-section="overview"]');
    var compactVisible = isMobile && compact && overview && overview.getBoundingClientRect().bottom < 0;
    var marker = isMobile ? (compactVisible ? getHeaderOffset() + compact.getBoundingClientRect().height + 20 : 80) : Math.max(110, window.innerHeight * 0.28);
    var active = targets[0];
    targets.forEach(function (target) {
      if (target.getBoundingClientRect().top - marker <= 0) active = target;
    });
    if (active) setActiveSection(active.getAttribute('data-compare-section'));
  }

  function updateCompactVisibility() {
    var compact = root.querySelector('[data-compare-compact]');
    var stage = root.querySelector('[data-compare-section="overview"]');
    if (!compact || !stage) return;
    var visible = stage.getBoundingClientRect().bottom < 0;
    compact.classList.toggle('is-visible', visible);
    compact.setAttribute('aria-hidden', visible ? 'false' : 'true');
    compact.toggleAttribute('inert', !visible);
  }

  function onScroll() {
    if (scrollFrame) return;
    scrollFrame = window.requestAnimationFrame(function () {
      scrollFrame = null;
      updateHeaderVisibility();
      updateActiveFromScroll();
      updateCompactVisibility();
    });
  }

  function setupObservers() {
    if (navObserver) navObserver.disconnect();
    if ('IntersectionObserver' in window) {
      navObserver = new IntersectionObserver(function () {
        updateActiveFromScroll();
      }, { threshold: [0, 0.25, 0.6] });
      navigationOrder.forEach(function (id) {
        var target = document.getElementById(sectionTargetId(id));
        if (target) navObserver.observe(target);
      });
    }
    updateActiveFromScroll();
    updateCompactVisibility();
  }

  function render() {
    syncSlots();
    var title = root.querySelector('[data-compare-title]');
    if (title) title.textContent = isMobile ? config.ui.mobileTitle : config.ui.title;
    renderNavigation();
    renderProducts();
    renderCompact();
    syncPriceRows();
    renderSections();
    setActiveSection(state.activeSection);
    setHeaderHidden(false);
    lastScrollTop = getScrollTop();
    setupObservers();
  }

  root.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-product-trigger]');
    if (trigger && root.contains(trigger)) {
      var wrap = trigger.parentNode;
      var open = wrap.getAttribute('data-open') === 'true';
      closeProductMenus(wrap);
      setSectionPickerOpen(false);
      setProductMenuOpen(wrap, !open);
      if (!open) focusFirstOption(wrap);
      return;
    }

    var option = event.target.closest('[data-product-option]');
    if (option && root.contains(option)) {
      selectProduct(
        Number(option.getAttribute('data-slot')),
        option.getAttribute('data-product-id'),
        Boolean(option.closest('[data-compare-compact-products]'))
      );
      return;
    }

    var colorOption = event.target.closest('[data-color-option]');
    if (colorOption && root.contains(colorOption)) {
      selectColor(colorOption.getAttribute('data-product-id'), colorOption.getAttribute('data-color-id'));
      return;
    }

    var sectionTrigger = event.target.closest('[data-compare-section-trigger]');
    if (sectionTrigger && root.contains(sectionTrigger)) {
      var picker = sectionTrigger.parentNode;
      var sectionOpen = picker.getAttribute('data-open') === 'true';
      closeProductMenus(null);
      setSectionPickerOpen(!sectionOpen, picker);
      return;
    }

    var navLink = event.target.closest('[data-compare-nav-link]');
    if (navLink && root.contains(navLink)) {
      event.preventDefault();
      navigateTo(navLink.getAttribute('data-section-id'));
    }
  });

  root.addEventListener('keydown', function (event) {
    var trigger = event.target.closest('[data-product-trigger]');
    if (trigger && (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      var wrap = trigger.parentNode;
      closeProductMenus(wrap);
      setProductMenuOpen(wrap, true);
      focusFirstOption(wrap);
      return;
    }

    var sectionTrigger = event.target.closest('[data-compare-section-trigger]');
    if (sectionTrigger && (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      var picker = sectionTrigger.parentNode;
      closeProductMenus(null);
      setSectionPickerOpen(true, picker);
      var firstSection = picker.querySelector('[data-compare-section-menu] a');
      if (firstSection) firstSection.focus();
      return;
    }

    var option = event.target.closest('[data-product-option]');
    if (option && (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Home' || event.key === 'End')) {
      event.preventDefault();
      var options = Array.from(option.parentNode.querySelectorAll('[data-product-option]'));
      var currentIndex = options.indexOf(option);
      var nextIndex = event.key === 'Home' ? 0 :
        event.key === 'End' ? options.length - 1 :
        (currentIndex + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
      options[nextIndex].focus();
      return;
    }

    if (event.key === 'Escape') {
      var openProductWrap = event.target.closest('.compare-product__selector-wrap[data-open="true"]');
      var openSectionPicker = event.target.closest('[data-compare-picker][data-open="true"]');
      closeMenus();
      var restoreTarget = openProductWrap ? openProductWrap.querySelector('[data-product-trigger]') :
        openSectionPicker ? openSectionPicker.querySelector('[data-compare-section-trigger]') : null;
      if (restoreTarget) restoreTarget.focus();
    }
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    var insidePicker = target.closest && target.closest('.compare-product__selector-wrap, [data-compare-picker]');
    if (!insidePicker) closeMenus();
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('resize', syncPriceRows);

  var viewportChange = function () {
    var nextMobile = mobileQuery.matches;
    if (nextMobile === isMobile) return;
    isMobile = nextMobile;
    render();
  };
  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', viewportChange);
  } else {
    mobileQuery.addListener(viewportChange);
  }

  state.slots = defaultsForViewport();
  render();
})();
